class BESSAppSearchSection extends BESSAppBase {
    constructor() {
        super();
        this.present = $('.app-search-page').length > 0;
        if (!this.present) return;
        this.loadingNextPage = false;
        this.resultsLoadNode = $('.app-search-results-load');
        this.searchMyProjects = $('#app-search-projects');
        this.searchInput = $('.app-search-results-input');
        this.engineSelect = $('.app-project-engine-select');
        this.searchInput.onTypeAheadChange(this, this.#doSearch);
        this.searchMyProjects.onChangeKeyUp(this, this.#doSearch);
        this.engineSelect.onChangeKeyUp(this, this.#doSearch);
    }

    start() {
        if (!this.present) return;
        this.#loadParams();
        this.loader = new BESSDynamicLoader(this.resultsLoadNode, this.#resultsLoaded.bind(this), this.params);
    }

    #loadParams() {
        this.params = {
            'search': $.urlParam('search', ''),
            'projects': $.urlParam('projects', 'true'),
            'engine': $.urlParam('engine', '')
        }

        this.#updateUrl();
    }

    #doSearch() {
        let params = {
            'search': this.searchInput.val().trim(),
            'projects': this.searchMyProjects.isChecked() ? "true" : "false",
            'engine': this.engineSelect.val(),
        }

        if (_.isEqual(params, this.params)) {
            return;
        }
        this.params = params;
        this.#updateUrl();

        this.loader.reloadAndReplace(params);
    }

    #updateUrl() {

        let url = new URL(window.location.href);
        url.searchParams.set("search", this.params['search']);
        url.searchParams.set("projects", this.params['projects']);
        url.searchParams.set("engine", this.params['engine']);
        window.history.pushState({}, null, url);
    }

    #resultsLoaded() {
    }

}